import type { Viewer } from '../components/AppViewer/AppViewer';

export const captureImage = (
  viewer: Viewer,
  type?: string,
  quality?: number,
): Promise<Blob | null> => {
  const canvas = viewer.canvasRef.current!;
  return new Promise(resolve => {
    canvas.toBlob(
      blob => {
        resolve(blob);
      },
      type,
      quality,
    );
  });
};

const toExtension = (type?: string) => {
  switch (type) {
    case 'image/webp':
      return 'webp';
    case 'image/jpeg':
      return 'jpeg';
    default:
      return 'png';
  }
};

export const downloadImage = async (viewer: Viewer, type?: string) => {
  const blob = await captureImage(viewer, type);
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob!);
  link.download = `screenshot.${toExtension(type)}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  link.remove();
};
